<template>
  <div class="content-card agb-data terms-and-notes">
      <slot name="headline"></slot>
      <div id="txtAGBText" class="inline-text agb-consent">
        <span><slot name="txtAGBwithLink"></slot></span>
      </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import syncProperty from '@/mixins/syncProperty'
import axios from 'axios'
import FileSaver from 'file-saver'
import appFileSaver from '@/mixins/appFileSaver'

export default {
  name: 'AGB',
  mixins: [
    syncProperty('agreed', 'agreedProp'),
    appFileSaver
  ],
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    contractDocumentUrl () {
      return this.$store.getters['checkoutv2/' + this.process + '/contractDocumentUrl']
    },
    isIosDevice () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  methods: {
    isBelatedMnp: function () {
      return this.process === 'belatedPorting'
    },
    downloadDocumentWithAuth () {
      const me = this
      axios.get(this.contractDocumentUrl, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const filename = 'Vertragszusammenfassung.pdf'
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        if (this.appTriggerSaveAsFileAvailable()) {
          this.appTriggerSaveAsFile(filename, file)
        } else {
          FileSaver.saveAs(file, filename)
        }
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei.')
      })
    },
    downloadDocumentWithoutAuth () {
      const baseUrl = this.$config.apiUrl
      if (typeof window.openNewWindowUrlInApp === 'function') {
        window.openNewWindowUrlInApp(`${baseUrl}${this.contractDocumentUrl}`)
      } else {
        window.open(`${baseUrl}${this.contractDocumentUrl}`)
      }
    }
  },
  mounted () {
    this.agreedProp = true
    const _this = this
    this.$nextTick(() => {
      const elem = document.getElementById('link_contract_summary')
      if (elem) {
        elem.addEventListener('click', (e) => {
          if (e.preventDefault) e.preventDefault()
          if (e.stopPropagation) e.stopPropagation()
          if (this.contractDocumentUrl) {
            _this.agreedProp = true
            if (this.isBelatedMnp()) {
              this.downloadDocumentWithAuth()
            } else {
              this.downloadDocumentWithoutAuth()
            }
            // tracking
            if (typeof window.trackingNS?.track?.tracking === 'function' && typeof window.trackingNS?.track?.getFileNameByUrl === 'function') {
              const data = {
                file_name: window.trackingNS.track.getFileNameByUrl(this.contractDocumentUrl)
              }
              window.trackingNS.track.tracking('download file', data)
            }
          }
          return false
        })
      }
    })
  }
}
</script>
